import { Component, HostListener, OnInit } from '@angular/core'
import { RouterLink, RouterLinkActive, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { ApiService, Store } from '../services/api.service'
import { ThemeService } from '../services/theme.service'

@Component({
  selector: 'app-admin-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './admin-navbar.component.html',
  styleUrl: './admin-navbar.component.css'
})
export class AdminNavbarComponent implements OnInit {
  isProfileMenuOpen = false
  store: Store | null = null

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private themeService: ThemeService,
    public router: Router
  ) { }

  ngOnInit() {
    if (!this.isSuperAdmin) {
      this.apiService.getStores({ mine: true }).subscribe({
        next: (stores) => { this.store = stores[0] ?? null },
        error: () => {}
      })
    }
  }

  get isSuperAdmin() {
    return this.authService.currentUser()?.role === 'super-admin'
  }

  get portalRoute() {
    return this.isSuperAdmin ? '/super-admin/overview' : '/admin'
  }

  get roleLabel() {
    return this.isSuperAdmin ? 'Super Admin' : 'Admin'
  }

  get currentUser() {
    return this.authService.currentUser()
  }

  get storeInitials(): string {
    return (this.store?.name ?? '').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase() || 'S'
  }

  get storeProductsRoute(): string {
    return this.store ? `/admin/stores/${this.store.username}` : '/admin'
  }

  isActive(path: string): boolean {
    return this.router.url === path || this.router.url.startsWith(path + '/')
  }

  onLogout() {
    this.closeProfileMenu()
    this.authService.logout()
  }

  toggleProfileMenu(event?: MouseEvent) {
    event?.stopPropagation()
    this.isProfileMenuOpen = !this.isProfileMenuOpen
  }

  closeProfileMenu() {
    this.isProfileMenuOpen = false
  }

  onProfileMenuClick(event: MouseEvent) {
    event.stopPropagation()
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.closeProfileMenu()
  }
}
